module.exports = __webpack_public_path__ + "img/no-img.0ca14100.svg";